import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminMarketingToolsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/marketing_tools',
  validateSearch: z.object({
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/MarketingTools/AdminMarketingToolsPage/AdminMarketingToolsPage').then(
    (d) => d.Route
  )
);
